import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSeo = lazy(() => import("@/pages/admin/AdminSeo"));

export const Route = createFileRoute("/admin/seo")({
  component: () => <AdminSeo />,
});
